<template>
  <section class="py-28 relative bg-gray-50 dark:bg-dark transition-colors duration-300">
    <div class="container mx-auto px-4">
      <div class="max-w-3xl mx-auto text-center mb-16">
        <h2 class="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white tracking-tight transition-colors duration-300">
          {{ t('faq.title') }}
        </h2>
      </div>

      <div class="max-w-2xl mx-auto">
        <div class="divide-y divide-gray-200 dark:divide-white/[0.06] transition-colors duration-300">
          <div v-for="(faq, index) in faqs" :key="index">
            <button 
              @click="toggleFaq(index)"
              class="w-full flex justify-between items-center py-5 text-left group"
            >
              <h3 class="text-[15px] font-medium text-gray-900 dark:text-white pr-8 group-hover:text-gray-600 dark:group-hover:text-gray-200 transition-colors">{{ faq.question }}</h3>
              <ChevronDown 
                class="h-4 w-4 text-gray-400 dark:text-gray-600 flex-shrink-0 transition-transform duration-200"
                :class="{ 'rotate-180': activeIndex === index }"
              />
            </button>
            <div 
              v-show="activeIndex === index"
              class="pb-5 -mt-1"
            >
              <p class="text-sm text-gray-500 leading-relaxed">{{ faq.answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ChevronDown } from 'lucide-vue-next'

const { t, tm } = useI18n()
const activeIndex = ref(null)

const faqs = computed(() => {
  const questions = tm('faq.questions')
  return Array.isArray(questions) ? questions : []
})

const toggleFaq = (index) => {
  activeIndex.value = activeIndex.value === index ? null : index
}
</script>
